/**
 * This is a wrapper component for different Layouts.
 * Topbar should be added to this wrapper.
 */
import React from 'react';
import classNames from 'classnames';

import css from './LayoutWrapperTopbar.css';

const LayoutWrapperTopbar = props => {
  const { className, rootClassName, children } = props;
  const classes = classNames(rootClassName || css.root, className);

  return <div className={classes}>{children}</div>;
};

export default LayoutWrapperTopbar;
